<template>
	<div>
		<div class="d-flex justify-content-between">
			<div class="d-flex gap-x-2">
				<h1 class="font-weight-bolder">Reporte de incidencias</h1>
				<b-button-group class="mb-1">
					<b-button
						@click="category_id = 1"
						:variant="category_id === 1 ? 'primary' : 'outline-primary'"
						:active="category_id === 1"
					>
						Padrillos
					</b-button>
					<b-button
						@click="category_id = 2"
						:variant="category_id === 2 ? 'primary' : 'outline-primary'"
						:active="category_id === 2"
					>
						Madrillas
					</b-button>
				</b-button-group>
			</div>
		</div>
		<b-row :key="category_id">
			<b-col cols="6">
				<div class="p-1 bg-white card m-0 h-100">
					<TopSonIncidencesChart :category_id="category_id" />
				</div>
			</b-col>
			<b-col cols="6">
				<div class="p-1 bg-white card m-0 h-100">
					<TopSonIncidencesTableDetail :category_id="category_id" />
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import TopSonIncidencesChart from "@/views/amg/specimens/components/mainDashboard/top-son-incidences/components/TopSonIncidencesChart.vue"
import TopSonIncidencesTableDetail from "@/views/amg/specimens/components/mainDashboard/top-son-incidences/components/TopSonIncidencesTableDetail.vue"
export default {
	components: {
		TopSonIncidencesChart,
		TopSonIncidencesTableDetail,
	},
	data() {
		return {
			category_id: 1,
		}
	},
}
</script>
